import styled from 'styled-components';

export const BottomNavigation = styled.div`
  text-align: right;
`;

export const StepBody = styled.div`
  flex-grow: 1;

  > * + * {
    margin-top: 16px;
  }
`;

export const StepContent = styled.div`
  background: #fff;
  padding: 32px;
  border-radius: 5px;
  height: 500px;
  overflow-y: auto;
  margin-bottom: 24px;
`;

export const Layout = styled.div`
  display: flex;
  background: #f9f7f7;
  padding: 72px 56px 32px 56px;
  width: 1000px;
  color: #444;

  > * + * {
    margin-left: 32px;
  }
`;

export const SectionTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 24px;
`;
